import { NextLabel, TextInput, TextInputProps } from '@cint/wonderment';
import { useController, useFormContext } from 'react-hook-form';

interface TextInputFieldProps
  extends Omit<TextInputProps, 'value' | 'onChange'> {
  name: string;
  label?: string;
  containerClassName?: string;
  isRequired?: boolean;
}

export const TextInputField = ({
  name,
  label,
  containerClassName,
  isRequired = true,
  ...props
}: TextInputFieldProps) => {
  const { control } = useFormContext();

  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({
    control,
    name,
  });

  return (
    <div className={containerClassName}>
      {label && <NextLabel label={label} size="sm" isRequired={isRequired} />}
      <TextInput
        {...props}
        id={name}
        value={value}
        onChange={onChange}
        decoratorTextProps={{
          ...props.decoratorTextProps,
          description: error?.message || props.decoratorTextProps?.description,
        }}
        hasError={!!error}
      />
    </div>
  );
};
